/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  ICurveRegistriesPoolsManagement,
  ICurveRegistriesPoolsManagementInterface,
} from "../ICurveRegistriesPoolsManagement";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "PoolAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "_pool",
        type: "address",
      },
    ],
    name: "PoolRemoved",
    type: "event",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "addr",
            type: "address",
          },
          {
            internalType: "bool",
            name: "isMeta",
            type: "bool",
          },
        ],
        internalType: "struct Pool[]",
        name: "_pools",
        type: "tuple[]",
      },
    ],
    name: "addPools",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_pools",
        type: "address[]",
      },
    ],
    name: "removePools",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ICurveRegistriesPoolsManagement__factory {
  static readonly abi = _abi;
  static createInterface(): ICurveRegistriesPoolsManagementInterface {
    return new utils.Interface(
      _abi
    ) as ICurveRegistriesPoolsManagementInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ICurveRegistriesPoolsManagement {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ICurveRegistriesPoolsManagement;
  }
}
